import {
  BasicTextStyleButton,
  FormattingToolbar,
  FormattingToolbarController,
} from '@blocknote/react';

/**
 * Provides the compact text-style toolbar used inside the dropdown editor.
 */
export function BlockNoteFormattingToolbar() {
  return (
    <FormattingToolbarController
      formattingToolbar={() => (
        <FormattingToolbar>
          <BasicTextStyleButton basicTextStyle="bold" key="boldStyleButton" />
          <BasicTextStyleButton
            basicTextStyle="italic"
            key="italicStyleButton"
          />
          <BasicTextStyleButton
            basicTextStyle="underline"
            key="underlineStyleButton"
          />
          <BasicTextStyleButton
            basicTextStyle="strike"
            key="strikeStyleButton"
          />
        </FormattingToolbar>
      )}
    />
  );
}
